export default  [
    {
        path: 'tela',
        redirect: 'tela/index',
        component: () => import(
            /* webpackChunkName: 'painel-senha-tela' */
            '@/views/painel-senha/tela/Index'
        ),
        children: [
            {
                name: 'painel-senha-tela-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'painel-senha-tela' */
                    '@/views/painel-senha/tela/List'
                ),
            },
            {
                name: 'painel-senha-tela-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'painel-senha-tela' */
                    '@/views/painel-senha/tela/Form.vue'
                ),
            },
            {
                name: 'painel-senha-tela-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'painel-senha-tela' */
                    '@/views/painel-senha/tela/Form.vue'
                ),
            },
        ],
    },
    {
        name: 'painel-senha-tela-show',
        path: 'tela/show/:id',
        meta: { layout: 'empty'},
        props: route => ({ id: parseInt(route.params.id) }),
        component: () => import(
            /* webpackChunkName: 'painel-senha-tela' */
            '@/views/painel-senha/tela/Show.vue'
        ),
    },
]